import rootStore from '../RootStore';
import * as _ from 'lodash';
import { IRootStoreExporter, IActivityRecord } from '../interfaces';
import moment from 'moment';
export enum E_EXPORT_TYPE {
    chart = 'chart',
    map = 'map',
}
import axios from 'axios';
import * as configService from './configService';

export interface IExport {
    type: E_EXPORT_TYPE;
    name: string;
    tags: string[];
    title: string;
    insight: string;
    elementSelector: string;
}

export default class ExportService {
    public static latestSnapshot: IActivityRecord = null;
    public static takeSnapshot(full: boolean = false) {
        const exportedState: any = {};

        for (const storeName in rootStore) {
            const store = (rootStore as any)[storeName] as {
                [key: string]: any;
            } & IRootStoreExporter;
            if (!store.customExport && !store.exportKeys) {
                continue;
            }
            if (
                store.customExport &&
                'function' === typeof store.customExport
            ) {
                exportedState[storeName] = store.customExport();
                continue;
            }
            exportedState[storeName] = {};
            const storeExport = exportedState[storeName];
            const keys = store.exportKeys();
            _.forEach(keys, key => {
                if (store.exportConverter) {
                    storeExport[key] = store.exportConverter(key, store[key]);
                    return;
                }
                const value = store[key];
                storeExport[key] = moment.isMoment(value)
                    ? value.toDate()
                    : value;
            });
        }
        return exportedState;
    }

    public static async exportPrediction(predictionId: string) {
        const axiosInstance = axios.create({
            baseURL: configService.getConnectionString().api,
            responseType: 'blob',
            withCredentials: true,
        });
        const result = await axiosInstance.get(
            `in/export_prediction/${predictionId}`,
        );
        if(result.status !== 200){
            throw `Error exporting prediction`
        }
        return result;
    }
}
